import React from 'react';

export default function DeleteConfirmModal({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirm Deletion", 
    message = "Are you sure you want to delete this item? This action cannot be undone.", 
    isDeleting = false 
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex font-dynamic-title items-center justify-center bg-zinc-900/40 backdrop-blur-xs p-4">
            <div className="bg-white border border-zinc-200 rounded-lg shadow-xl w-full max-w-sm overflow-hidden">
                
                {/* Modal Header & Icon (Left Aligned) */}
                <div className="p-5 flex items-start gap-3.5 text-left">
                    <div>
                        <h3 className="text-sm font-bold text-zinc-900">
                            {title}
                        </h3>
                        <p className="text-xs text-zinc-500 mt-1 leading-relaxed">
                            {message}
                        </p>
                    </div>
                </div>

                {/* Actions (Right Aligned) */}
                <div className="flex items-center justify-end gap-2 px-5 py-3.5 bg-zinc-50 border-t border-zinc-100">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isDeleting}
                        className="px-3.5 py-1.5 text-xs font-medium text-zinc-700 bg-white border border-zinc-300 hover:bg-zinc-50 rounded-lg transition-colors disabled:opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isDeleting}
                        className="px-3.5 py-1.5 text-xs font-semibold text-white bg-rose-600 hover:bg-rose-700 rounded-lg transition-colors shadow-sm disabled:opacity-50"
                    >
                        {isDeleting ? "Deleting..." : "Delete"}
                    </button>
                </div>

            </div>
        </div>
    );
}